import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=dd10f2c6&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"
import style0 from "./Tables.vue?vue&type=style&index=0&id=dd10f2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd10f2c6",
  null
  
)

export default component.exports